import { useState } from "react";
// react-router-dom components

// @mui material components
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";

// Material Kit 2 PRO React components
import MKBox from "../../components/MKBox";
import MKTypography from "../../components/MKTypography";

import colors from "../../assets/theme/base/colors";
// Image

function DashboardTitle(props) {
  const { typographyColor, isXs } = props;

  const [mainHeaderTitle, setMainHeaderTitle] = useState("FEMS2.0");
  const [subHeaderTitle, setSubHeaderTitle] = useState(
    ""
    // "More than a developer, We transform industries."
  );

  const renderTypographiesForPage = (mColor) => {
    return (
      <>
        <Grid
          container
          sx={{
            display: {
              xs: "none",
              md: "flex",
              backgroundImage: ({
                functions: { linearGradient, rgba },
                palette: { gradients },
              }) =>
                `${linearGradient(
                  rgba(gradients.dark.main, 0.4),
                  rgba(gradients.dark.state, 0.2)
                )} `,
              opacity: "95%",
            },
          }}
        >
          <Grid item xs={12}>
            <MKBox minWidth="100%">
              <MKTypography
                fontWeight="bold"
                fontSize={isXs ? "0.3vw" : "1.5vw"}
                style={{
                  fontFamily: "Barlow",
                  color: mColor,
                  fontWeight: "500",
                }}
              >
                {subHeaderTitle}
              </MKTypography>
            </MKBox>
          </Grid>
          <Grid item xs={12} mt={-1}>
            <MKBox minWidth="100%">
              <MKTypography
                fontWeight="bold"
                style={{
                  fontFamily: "Barlow",
                  fontSize: isXs ? "1.3vw" : "3.9vw",
                  // fontSize: "3.5vw",
                  color: typographyColor,
                  fontWeight: "600",
                }}
              >
                {mainHeaderTitle}
              </MKTypography>
            </MKBox>
          </Grid>
        </Grid>
        <Grid container sx={{ display: { xs: "flex", md: "none" } }}>
          <Grid item xs={12}>
            <MKTypography
              fontWeight="bold"
              fontSize="0.7rem"
              style={{ fontFamily: "Barlow", color: mColor, fontWeight: "500" }}
            >
              {subHeaderTitle}
            </MKTypography>
          </Grid>
          <Grid item xs={12} mt={-1}>
            <MKTypography
              fontWeight="bold"
              sx={({ breakpoints, typography: { size } }) => ({})}
              style={{
                fontFamily: "Barlow",
                fontSize: "8.0vw",
                color: typographyColor,
                fontWeight: "600",
              }}
            >
              {mainHeaderTitle}
            </MKTypography>
          </Grid>
        </Grid>
      </>
    );
  };

  return renderTypographiesForPage(typographyColor);
}

DashboardTitle.defaultProps = {
  typographyColor: colors.white.focus,
  isXs: false,
};

export default DashboardTitle;
